import { render, staticRenderFns } from "./BrokerReportPlans.vue?vue&type=template&id=5fdcb2d8"
import script from "./BrokerReportPlans.vue?vue&type=script&lang=js"
export * from "./BrokerReportPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports